import React from "react";
import { useRouteMatch } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { PageTitles } from "../../constants";
import { SummaryCard } from "../../components/SummaryCard";
import { RoutingTabs } from "../../components/RoutingTabs";
import { APP_ROUTES, getParamsAttachedRoute } from "../../helpers/routeHelpers";
import NarratorListing from "./NarratorManagement/NarratorListing";
import AuthorListing from "./AuthorManagement/AuthorListing";
import NarratorDetails from "./NarratorManagement/NarratorDetails";
import AuthorDetails from "./AuthorManagement/AuthorDetails";
import AddAuthor from "./AuthorManagement/AddAuthor";
import AddNarrator from "./NarratorManagement/AddNarrator";
import UpdateNarrator from "./NarratorManagement/UpdateNarrator";
import UpdateAuthor from "./AuthorManagement/UpdateAuthor";
// import AuthorDetails from "./AuthorManagement/AuthorDetails";
// import NarratorDetails from "./NarratorManagement/NarratorDetails";
// import NarratorDetails from "./NarratorManagement/NarratorDetails";
// import AuthorDetails from "./AuthorManagement/AuthorDetails";

const AuthorAndNarratorManagement = () => {
    const matches = useRouteMatch();
    const CONFIG = {
        tabsConfig: [
            {
                title: "Narrator",
                id: "1",
                defaultActive: true,
                exact: true,
                path: APP_ROUTES.NARRATOR_MANAGEMENT,
                component: <NarratorListing />,
                // children: []
                children: [
                    {
                        path: APP_ROUTES.NARRATOR_ADD,
                        exact: true,
                        component: <AddNarrator />
                    },
                    {
                        path: getParamsAttachedRoute(APP_ROUTES.NARRATOR_EDIT, {
                            id: matches?.params?.id
                        }),
                        exact: false,
                        component: <UpdateNarrator />
                    },
                    {
                        path: getParamsAttachedRoute(APP_ROUTES.NARRATOR_DETAILS, {
                            id: matches?.params?.id
                        }),
                        exact: false,
                        component: <NarratorDetails />
                    }
                ]
            },

            {
                title: "Author",
                id: "2",
                defaultActive: false,
                exact: true,
                path: APP_ROUTES.AUTHOR_MANAGEMENT,
                component: <AuthorListing />,
                // children: []
                children: [
                    {
                        path: APP_ROUTES.AUTHOR_ADD,
                        exact: true,
                        component: <AddAuthor />
                    },
                    {
                        path: getParamsAttachedRoute(APP_ROUTES.AUTHOR_EDIT, {
                            id: matches?.params?.id
                        }),
                        exact: false,
                        component: <UpdateAuthor />
                    },
                    {
                        path: getParamsAttachedRoute(APP_ROUTES.AUTHOR_DETAILS, {
                            id: matches?.params?.id
                        }),
                        exact: false,
                        component: <AuthorDetails />
                    }
                ]
            }
        ]
    };

    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.AUTHOR_AND_NARRATOR_MANAGEMENT}</title>
            </Helmet>
            <Container fluid>
                <SummaryCard
                    cardProps={{
                        style: { padding: "0px" }
                    }}
                >
                    <RoutingTabs
                        config={CONFIG}
                        isPills
                        isTabs={true}
                        parentRoute={APP_ROUTES.AUTHOR_AND_NARRATOR_MANAGEMENT}
                    />
                </SummaryCard>
            </Container>
        </div>
    );
};

export default AuthorAndNarratorManagement;
